import { createContext, useContext, useState, ReactNode } from 'react'

import { TMsalLoginRequest } from './msalContext.types'
import { IMsalContextType } from './msalContext.interfaces'

const MsalContext = createContext<IMsalContextType | undefined>(undefined)

export const MsalContextProvider = ({ children }: { children: ReactNode }) => {
  const [loginRequest, setLoginRequest] = useState<TMsalLoginRequest | null>(null)

  const handleLoginRequestChange = (loginRequest: TMsalLoginRequest) =>
    setLoginRequest(loginRequest)

  return (
    <MsalContext.Provider value={{ loginRequest, handleLoginRequestChange }}>
      {children}
    </MsalContext.Provider>
  )
}

export const useMsalContext = () => {
  const context = useContext(MsalContext)
  if (!context) {
    throw new Error('MsalContextProvider.useMsalContext : useAuth must be used in an AuthProvider')
  }
  return context
}
